var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiselect-picker-option",class:_vm.optionClass},[_c('span',{staticClass:"multiselect-picker-option__icon"},[_c(_vm.icon,{tag:"component",attrs:{"size":20}})],1),_vm._v(" "),_c('span',{staticClass:"multiselect-picker-option__label"},[_vm._v("\n\t\t"+_vm._s(_vm.displayName)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }